import { SELECTED_RETAILER } from "./type"

export const selectedRetailer=(data)=>{
    return{
        type: SELECTED_RETAILER,
        payload: data

    }
}